import Highcharts from 'highcharts';
import { TimelineAxisSide, TimelineAxisTypes, TimelineNumericSeries, TimelineSeriesCustomData } from '../../../shared';
// @ts-expect-error @types collides with node_modules/@types
import { TimelineNumericSeriesType } from '@types/graphql-global-types';

export type NumericSeriesDataItem = {
    label: string;
    value: {
        Date: string;
        Y: string;
        Threshold?: {
            Upper?: number;
            Lower?: number;
        };
    };
};

type MapNumericMainSeriesOptions = {
    id: string;
    series: TimelineNumericSeries;
    side: TimelineAxisSide;
    themeColor: string;
    isFloat: boolean;
    unit?: string;
    pointEvents?: Highcharts.PointEventsOptionsObject;
};
export function mapNumericMainSeries({
    id,
    series,
    side,
    themeColor,
    isFloat,
    unit,
    pointEvents,
}: MapNumericMainSeriesOptions): (Highcharts.SeriesLineOptions | Highcharts.SeriesScatterOptions) &
    TimelineSeriesCustomData {
    return {
        id,
        yAxis: side,
        name: series.series.label,
        type: series.series.type === TimelineNumericSeriesType.LINE ? 'line' : 'scatter',
        data: (series.data as NumericSeriesDataItem[])
            .map((item) => [new Date(item.value.Date).getTime(), parseFloat(item.value.Y)])
            .sort((a, b) => a[0] - b[0]),
        color: themeColor,
        lineWidth: series.series.type === TimelineNumericSeriesType.LINE ? 1 : undefined,
        marker: {
            symbol: 'circle',
            enabled: true,
            radius: 4.5,
        },
        stickyTracking: false,
        custom: {
            axisType: TimelineAxisTypes.Numeric,
        },
        isFloat,
        unit,

        point: {
            events: pointEvents,
        },
    };
}
